export default {
    "driver_performance_historyTooltip_noHistory": "No history available",
    "driver_performance_historyTooltip_status": "Status",
    "driver_performance_historyTooltip_statusEvaluation": "Evaluation",
    "driver_performance_historyTooltip_statusEscalation": "Escalation",
    "driver_performance_historyTooltip_effectiveDate": "Effective Date",
    "driver_performance_historyTooltip_metric": "Metric",
    "driver_performance_historyTooltip_measure": "Measure",
    "driver_performance_historyTooltip_target": "Target",
    "driver_performance_historyTooltip_byDistance": "By Distance",
    "driver_performance_historyTooltip_avgevents": "Avg Events",
    "driver_performance_historyTooltip_riskscore": "Risk Score",
    "driver_performance_historyTooltip_events": "Events",
    "driver_performance_historyTooltip_totaldistance": "Total Distance"
};
